import React from 'react';
import cn from 'classnames';

import ScoreCard from 'components/kpi/ScoreCard.component';
import { useTheme } from 'providers/Theme.provider';
import alen from 'utils/arrays/alen.util';
import noNilArray from 'utils/arrays/noNilArray.util';
import logger from 'utils/logger.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

import NoStylistDataPreview from './NoStylistDataPreview.component';

import CN from './ScoreTable.module.scss';

const L = logger('ScoreTable'); // eslint-disable-line no-unused-vars

const ScoreTable = React.forwardRef(({ value: scores }, ref) => {
  const { isDarkMode } = useTheme();

  return (
    <div
      data-bem="ScoreTable"
      className={cn({
        [CN.component]: true,
        [CN.dark]: isDarkMode,
      })}
    >
      <div className={CN.outer} ref={ref}>
        {isFullArray(scores) ? (
          <div data-bem="ScoreTable__scores" data-count={alen(scores)} className={CN.cardsContainer}>
            {noNilArray(scores).map((score) => (
              <ScoreCard
                key={`${score.stylistId}--${score.bgn}--${score.end}`}
                stylistId={score.stylistId}
                bgn={score.bgn}
                end={score.end}
                kind={score.kind}
                value={score.performances}
                isBusiness={score.isBusiness}
                isForecast={score.isForecast}
              />
            ))}
          </div>
        ) : (
          // NOTE: But we also have another preview design for the unselected date picker -> <NoSelectionPreview />
          <NoStylistDataPreview />
        )}
      </div>
    </div>
  );
});

export default ScoreTable;
